import { Typography } from '@mui/material'
import React from 'react'
import { UploadImage } from '../../assets/icons'

const ImageUpload = ({ selectedImage, onFileChange, label, profile, req }) => {
  const fileInputRef = React.useRef(null)
  const handleChooseFileClick = () => {
    fileInputRef.current.click()
  }

  return (
    <div>
      <Typography className="field-label">
        {label}
        {req && <span className="req">*</span>}
      </Typography>
      <div className={profile ? 'upload-profile-image' : 'upload-image'}>
        {!profile && (
          <img
            src={selectedImage ? selectedImage : UploadImage}
            alt="Selected Avatar"
            className="selected-image"
          />
        )}
        <div className={profile && 'add-profile-image-p'}>
          <div className="choose-image" onClick={handleChooseFileClick}>
            Choose File
          </div>
          <Typography className="supported-text">Supported file .jpg, .png, .jpeg</Typography>
        </div>
        <input
          type="file"
          accept=".jpg, .jpeg, .png"
          className="input-image"
          onChange={onFileChange}
          ref={fileInputRef}
          style={{ display: 'none' }}
        />
      </div>
    </div>
  )
}
export default ImageUpload

export const AadharImage = ({
  label,
  onFileChange,
  fileName,
  margin,
  studentForm,
  individualStudentForm,
  required,
  Aadhar
}) => {
  const fileInputRef = React.useRef(null)
  const handleChooseFileClick = () => {
    fileInputRef.current.click()
  }
  return (
    <div
      style={{
        margin,
        display: individualStudentForm ? 'flex' : '',
        gap: individualStudentForm ? '56px' : '',
      }}
    >
      {!studentForm && (
        <Typography
          mb={margin ? 0 : 1}
          sx={{
            width: individualStudentForm ? '156px' : 'fit-content',
          }}
          className="field-label"
        >
          {label} {required && !Aadhar && <span className="req">*</span>}
        </Typography>
      )}

      <div
        style={{
          borderRadius: studentForm ? ' 0px 0px 8px 8px' : '',
          width: individualStudentForm ? 'auto' : '',
          minWidth: individualStudentForm ? 'unset' : '',
          flex: individualStudentForm ? '1 0 0' : '',
        }}
        className="aadahr-container"
      >
        <Typography
          sx={{
            color: 'var(--Gray-400, #98A1B2)',
            fontFamily: 'Satoshi',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '132%',
            fontVariantNumeric: 'lining-nums proportional-nums',
            fontFeatureSettings: "'dlig' on",
          }}
        >
          {fileName}
        </Typography>
        <Typography className="choose-aadhar" onClick={handleChooseFileClick}>
          Choose File
        </Typography>
      </div>
      <input
        type="file"
        // accept=".jpg, .jpeg, .png"
        className="input-image"
        onChange={onFileChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
    </div>
  )
}
